var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.0305 22.939H12.9695C12.4341 22.939 12 23.373 12 23.9084C12 24.4439 12.4341 24.8779 12.9695 24.8779H35.0305C35.566 24.8779 36 24.4439 36 23.9084C36 23.373 35.566 22.939 35.0305 22.939Z","fill":"white","key":0}),React.createElement("path",{"d":"M35.0305 15H12.9695C12.4341 15 12 15.4341 12 15.9695C12 16.5049 12.4341 16.9389 12.9695 16.9389H35.0305C35.566 16.9389 36 16.5049 36 15.9695C36 15.4341 35.566 15 35.0305 15Z","fill":"white","key":1}),React.createElement("path",{"d":"M35.0305 30.8779H12.9695C12.4341 30.8779 12 31.3119 12 31.8474C12 32.3829 12.4341 32.8169 12.9695 32.8169H35.0305C35.566 32.8169 36 32.3829 36 31.8474C36 31.3119 35.566 30.8779 35.0305 30.8779Z","fill":"white","key":2})]);
}

Menu.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
